import { api } from './client';
import type { Envelope } from './types';

export interface ExpenseShare {
  userId: string;
  shareAmount: number;
  bearsRemainder: boolean;
}

export interface Expense {
  id: string;
  meetingId: string;
  scheduleItemId: string | null;
  paidByUserId: string;
  amount: number;
  currency: string;
  description: string | null;
  occurredAt: string;
  createdAt: string;
  shares: ExpenseShare[];
  settlementRecomputed: boolean;
}

export async function listExpenses(meetingId: string) {
  const { data } = await api.get<Envelope<Expense[]>>(`/meetings/${meetingId}/expenses`);
  return data.data;
}

export async function createExpense(
  meetingId: string,
  input: {
    scheduleItemId?: string | null;
    paidByUserId?: string;
    amount: number;
    description?: string;
    occurredAt?: string;
    shares?: ExpenseShare[];
  },
) {
  const { data } = await api.post<Envelope<Expense>>(`/meetings/${meetingId}/expenses`, input);
  return data.data;
}

export async function deleteExpense(expenseId: string) {
  await api.delete(`/expenses/${expenseId}`);
}

export interface ExpenseReceipt {
  id: string;
  expenseId: string;
  contentType: string;
  sizeBytes: number;
  createdAt: string;
}

/** 영수증이 첨부된 expenseId 목록 (배지 표시용). */
export async function listReceiptExpenseIds(meetingId: string): Promise<string[]> {
  const { data } = await api.get<Envelope<string[]>>(`/meetings/${meetingId}/expense-receipts`);
  return data.data;
}

export async function uploadReceipt(expenseId: string, file: File): Promise<ExpenseReceipt> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post<Envelope<ExpenseReceipt>>(
    `/expenses/${expenseId}/receipt`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data.data;
}

/** 인증 헤더가 필요해 <img src> 대신 blob 으로 받아 object URL 로 띄운다. */
export async function fetchReceiptBlob(expenseId: string): Promise<Blob> {
  const { data } = await api.get<Blob>(`/expenses/${expenseId}/receipt`, {
    responseType: 'blob',
  });
  return data;
}

export async function deleteReceipt(expenseId: string) {
  await api.delete(`/expenses/${expenseId}/receipt`);
}
